// Reconstructed from the supplied production build; original component names were unavailable.
import { api } from "./client.js";
const authApi = {
  login: async (a, n) => {
    try {
      return (
        await api.post("/auth/login", {
          email: a,
          password: n,
        })
      ).data;
    } catch (i) {
      throw i.response ? i.response.data : new Error("Network error");
    }
  },
  register: async (a, n, i, l) => {
    try {
      return (
        await api.post("/auth/register", {
          name: a,
          phone: n,
          email: i,
          password: l,
        })
      ).data;
    } catch (c) {
      throw c.response ? c.response.data : new Error("Network error");
    }
  },
  verifyEmail: async (a, n) => {
    try {
      return (
        await api.post("/auth/verify", {
          userId: a,
          otp: n,
        })
      ).data;
    } catch (i) {
      throw i.response ? i.response.data : new Error("Network error");
    }
  },
  resendOTP: async (a) => {
    try {
      return (
        await api.post("/auth/resend-otp", {
          email: a,
        })
      ).data;
    } catch (n) {
      throw n.response ? n.response.data : new Error("Network error");
    }
  },
  getCurrentUser: async () => {
    try {
      return (await api.get("/auth/current-user")).data;
    } catch (a) {
      throw a.response ? a.response.data : new Error("Network error");
    }
  },
  logout: async () => {
    try {
      return (await api.post("/auth/logout")).data;
    } catch (a) {
      throw a.response ? a.response.data : new Error("Network error");
    }
  },
  loginWithGoogle: () => {
    window.location.href = `${api.defaults.baseURL}/auth/google`;
  },
};
export { authApi };
